import React from "react";

const GoogleChromeIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5409_22704)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.99973 14.499C12.485 14.499 14.4997 12.4843 14.4997 9.99903C14.4997 7.51375 12.485 5.49903 9.99973 5.49903C7.51444 5.49903 5.49973 7.51375 5.49973 9.99903C5.49973 12.4843 7.51444 14.499 9.99973 14.499Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.1026 12.25L2.20611 5.50111C1.41603 6.86911 1.00005 8.42103 1 10.0008C0.999946 11.5806 1.41582 13.1325 2.2058 14.5006C2.99578 15.8686 4.13203 17.0046 5.50029 17.7943C6.86854 18.5839 8.42057 18.9994 10.0003 18.9989L13.8968 12.25V12.2489C13.5022 12.9333 12.9343 13.5017 12.2502 13.8969C11.5661 14.2921 10.7901 14.5003 10.0001 14.5004C9.21003 14.5005 8.43389 14.2926 7.74971 13.8975C7.06557 13.5025 6.49746 12.9343 6.1026 12.25Z",
  fill: "url(#paint0_linear_5409_22704)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8965 12.2497L10.0001 18.9987C11.5798 18.9989 13.1318 18.5832 14.5 17.7933C15.8681 17.0035 17.0042 15.8674 17.794 14.4992C18.5838 13.131 18.9994 11.579 18.9992 9.99922C18.9989 8.41945 18.5827 6.86762 17.7924 5.49971H9.99941L9.99844 5.50031C10.7885 5.49991 11.5647 5.70757 12.249 6.10234C12.9333 6.49714 13.5016 7.06514 13.8967 7.74928C14.2918 8.4334 14.4998 9.20951 14.4998 9.99951C14.4998 10.7895 14.2917 11.5656 13.8966 12.2497H13.8965Z",
  fill: "url(#paint1_linear_5409_22704)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99971 13.5625C11.9672 13.5625 13.5622 11.9675 13.5622 10C13.5622 8.03248 11.9672 6.43748 9.99971 6.43748C8.0322 6.43748 6.43723 8.03248 6.43723 10C6.43723 11.9675 8.0322 13.5625 9.99971 13.5625Z",
  fill: "#1A73E8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99973 5.5H17.7927C17.003 4.13177 15.867 2.99556 14.4989 2.20563C13.1308 1.4157 11.5788 0.999888 9.99908 1C8.4193 1.00011 6.86742 1.41615 5.49945 2.20627C4.13145 2.99639 2.99562 4.13277 2.20612 5.50109L6.10259 12.25L6.10359 12.2505C5.70825 11.5665 5.49996 10.7905 5.4997 10.0005C5.49945 9.21049 5.70725 8.43431 6.10216 7.75009C6.49705 7.06586 7.06519 6.49766 7.74936 6.10269C8.43356 5.70769 9.2097 5.49983 9.99973 5.5Z",
  fill: "url(#paint2_linear_5409_22704)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5409_22704",
  x1: 10.9739,
  y1: 18.4369,
  x2: 3.18064,
  y2: 4.93849,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1E8E3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#34A853"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_5409_22704",
  x1: 8.68693,
  y1: 19.0225,
  x2: 16.4802,
  y2: 5.52414,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCC934"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBBC04"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_5409_22704",
  x1: 2.20612,
  y1: 6.62526,
  x2: 17.7927,
  y2: 6.62526,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D93025"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EA4335"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5409_22704"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white",
  transform: "translate(1 1)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleChromeIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;